import { Injectable, inject } from '@angular/core';
import { Storage, ref, getDownloadURL } from '@angular/fire/storage';

import { Photo } from './order.model';
import { thumbnailBlobName, webBlobName } from './photo.utils';

@Injectable({
  providedIn: 'root'
})
export class PhotoService {
  private storage = inject(Storage);

  // Resolves the resized copy, for previews that don't need full resolution.
  async getThumbnailUrl(photo: Photo): Promise<string> {
    return this.getPhotoUrl(thumbnailBlobName(photo));
  }

  // Resolves the screen-sized copy, for viewing a single photo.
  async getWebUrl(photo: Photo): Promise<string> {
    return this.getPhotoUrl(webBlobName(photo));
  }

  async getPhotoUrl(blobName: string): Promise<string> {
    if (!blobName) {
      throw new Error('No blob name provided');
    }

    try {
      const storageRef = ref(this.storage, blobName);
      return await getDownloadURL(storageRef);
    } catch (error) {
      console.error('Error getting download URL:', error);
      throw error;
    }
  }
}